(function () {
  'use strict';

  function dispatchCartEvents(cart) {
    var detail = { cart: cart, source: 'auraa-collection' };
    document.dispatchEvent(new CustomEvent('auraa:cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    window.dispatchEvent(new CustomEvent('auraa:cart:updated', { detail: detail }));
  }

  async function fallbackAdd(variantId, quantity) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function () { return {}; });
      throw new Error(errorData.description || 'Unable to add this item.');
    }

    var cartResponse = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    var cart = await cartResponse.json();
    dispatchCartEvents(cart);

    if (typeof window.refreshAuraaCart === 'function') {
      try { await window.refreshAuraaCart(); } catch (error) {}
    }

    if (typeof window.openAuraaCartDrawer === 'function') {
      window.openAuraaCartDrawer();
    }

    return cart;
  }

  function initQuickAdd(section) {
    section.querySelectorAll('[data-ac-add]').forEach(function (button) {
      if (button.dataset.acBound === 'true') return;
      button.dataset.acBound = 'true';

      button.addEventListener('click', async function () {
        if (button.disabled || button.classList.contains('is-loading')) return;

        var variantId = button.dataset.variantId;
        var label = button.querySelector('[data-ac-add-label]');
        var defaultText = button.dataset.defaultText || 'ADD TO CART';
        var loadingText = button.dataset.loadingText || 'ADDING';
        var successText = button.dataset.successText || 'ADDED';

        button.classList.add('is-loading');
        button.disabled = true;
        if (label) label.textContent = loadingText;

        try {
          if (window.AuraaCart && typeof window.AuraaCart.add === 'function') {
            await window.AuraaCart.add(variantId, 1);
            if (typeof window.AuraaCart.open === 'function') {
              window.AuraaCart.open();
            }
          } else {
            await fallbackAdd(variantId, 1);
          }

          if (label) label.textContent = successText;
          window.setTimeout(function () {
            if (label) label.textContent = defaultText;
          }, 1400);
        } catch (error) {
          console.error('[AURAA Collection]', error);
          if (label) label.textContent = defaultText;
        } finally {
          button.classList.remove('is-loading');
          window.setTimeout(function () {
            button.disabled = false;
          }, 450);
        }
      });
    });
  }

  function initSort(section) {
    var select = section.querySelector('[data-ac-sort]');
    if (!select || select.dataset.acBound === 'true') return;
    select.dataset.acBound = 'true';

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (select.value) {
        url.searchParams.set('sort_by', select.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.assign(url.toString());
    });
  }

  function initReveal(section) {
    var items = section.querySelectorAll('[data-ac-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function initSection(section) {
    if (!section || section.dataset.acInitialized === 'true') return;
    section.dataset.acInitialized = 'true';
    initQuickAdd(section);
    initSort(section);
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll('[data-auraa-collection]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-auraa-collection]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-auraa-collection]');
    if (section) initSection(section);
  });
})();